const prefix = '[CustomerApplicationDetail]';

export class LoadApplication {
    static readonly type = `${prefix} Load Application`;
    constructor(public applicationId: string) {}
}

export class LoadSelectedAwardCommitteeMeeting {
    static readonly type = `${prefix} Load Selected Award Committee Meeting`;
}

export class ResetApplicationDetailState {
    static readonly type = `${prefix} Reset State`;
}
